import { 
	GET_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITIONS, 
	GET_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITION,
	CREATE_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITION,
	UPDATE_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITION,
	DESTROY_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITION,
} from "./actions"

export function ProjectQaWeldingInspectionsViewingConditionsReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITIONS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITION}_FULFILLED`:
		case `${CREATE_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITION}_FULFILLED`:
		case `${UPDATE_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITION}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_QA_WELDING_INSPECTIONS_VIEWING_CONDITION}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectQaWeldingInspectionsViewingConditionsReducer } from "modules/project/qa/welding_inspections/viewing_conditions/reducer"

// project_qa_welding_inspections_viewing_conditions:ProjectQaWeldingInspectionsViewingConditionsReducer,
